<template>
  <div class="site-width site-center">
    <div class="links-auth q-px-sm">
      <q-btn
        :to="{ name: 'login' }"
        :label="$t('Login')"
        rounded
        color="white"
        text-color="primary"
        class="full-width"
      />
      <q-btn
        :to="{ name: 'register' }"
        :label="$t('Register')"
        rounded
        color="white"
        text-color="primary"
        icon="person_add"
        class="full-width"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'page-home',
  metaInfo: {
    title: 'Welcome',
    meta: [
      {
        vmid: 'Description',
        name: 'Description',
        content: 'Content',
      },
    ],
  },
};
</script>
<style lang="scss">
.page-home {
  .links-auth {
    // padding: 15vh 10vw;
    & > * + * {
      margin-top: 4vh;
    }
  }
}
</style>
